/*
 * Regras puras das telas de relatório do administrativo: o back devolve o arquivo .xls pronto
 * (como no JSF) e o nome do arquivo é montado aqui.
 */

export const MENSAGEM_ANO_SEMESTRE_OBRIGATORIO = 'É obrigatório';

export const NOME_ARQUIVO_CADASTRO_BOLSISTAS = 'relatorio_saf_tbols_todos.xls';

export const nomeArquivoTermosConcessao = anoSemestre => `relatorio_termos_concessao_bolsas_${anoSemestre}.xls`;

/* Parâmetros do GET dos termos de concessão. */
export const montarParametrosTermosConcessao = ({anoSemestre}) => ({anoSemestre});
